import React from 'react';
import cx from 'classnames';
import * as consts from '~/src/common/consts';

const ResultsTopBar = ({ direction, className, children }) => (
  <div
    className={cx(className, 'flex flex-nowrap items-center', 'b--solid bc-window-border bw1 br-0 bt-0 bl-0 bb-1', {
      'flex-direction': `${direction === consts.DIRECTION.HORIZONTAL ? 'row' : 'column'}`,
    })}
  >
    {children}
  </div>
);

export default ResultsTopBar;
